module.exports = __webpack_public_path__ + "img/avatar4.9f0d968b.png";